/* eslint-disable better-mutation/no-mutation */

import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type LoginSlice = {
    /**
     * This Kount Session ID is for login only!
     * If you need a Kount Session ID for other pages, you need to create a new one.
     *
     * "The Kount Session ID must be unique for every RIS post, even when multiple transactions occur in the same Web Session.
     * This means that the SDK setup must be re-invoked with a new Kount Session ID for every transaction.
     *
     * The Kount Session ID can be repeated within the same Web Session.
     * For example, multiple login attempts in a short time window (less than 15 minutes) can use the same Kount Session ID.
     * In this case, the DDC does not need to be restarted every time."
     * Source: https://developer.kount.com/hc/en-us/p/integration-builder?labels=WEB
     */
    kountSessionId: string;
    isKountDataCollected: boolean;
};

const initialState: LoginSlice = {
    kountSessionId: '',
    isKountDataCollected: false,
};

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        setIsKountSessionId: (state, action: PayloadAction<string>) => {
            state.kountSessionId = action.payload;
        },
        setIsKountDataCollected: (state, action: PayloadAction<boolean>) => {
            state.isKountDataCollected = action.payload;
        },
    },
});

export const { setIsKountSessionId, setIsKountDataCollected } =
    loginSlice.actions;

export default loginSlice.reducer;
